import { render, staticRenderFns } from "./AIChat.vue?vue&type=template&id=651b58c1&scoped=true"
import script from "./AIChat.vue?vue&type=script&lang=js"
export * from "./AIChat.vue?vue&type=script&lang=js"
import style0 from "./AIChat.vue?vue&type=style&index=0&id=651b58c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b58c1",
  null
  
)

export default component.exports